import { Component } from '@angular/core';
import { NavController, Events } from 'ionic-angular';

// Providers
import { ProvidersService } from '../../providers/providers/providers-service';
import { InstructorsService } from '../../providers/instructors/instructors-service';

// Helpers
import { HelperCsvService } from '../../providers/helpers/helper-csv-service';

// Pages
import { InstructorAddEditPage } from '../instructors/instructor-add-edit';

@Component({
  selector: 'page-report-active-provider',
  templateUrl: 'report.active-provider.html'
})
export class ReportActiveProviderPage {
  headerData: any;
  providers:any = [];
  gotRecords:boolean = false;

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public providersService: ProvidersService,
    public instructorsService: InstructorsService,
    public helperCsvService: HelperCsvService
  ) {
    this.headerData = { title: 'Active DE Providers' };
    this.getProviders();
  }

  getProviders()
  {
    this.providersService.getProviders( 'Active' )
      .subscribe( data => {
        this.providers = data;
        if ( this.providers.length > 0 )
        {
          this.gotRecords = true;
        }
      });
  }

  showInstructorAddEditPage( instructor = null )
  {
    this.navCtrl.push( InstructorAddEditPage, {
      instructor: instructor
    });
  }

  createReportCSV()
  {
    this.helperCsvService.exportProviderList( this.providers, 'Active DE Provider List.csv' );
  }
}


// WEBPACK FOOTER //
// ./src/pages/reports/report.active-provider.ts